import { Column, Entity, Index, JoinColumn, ManyToOne } from 'typeorm';
import { BaseEntity } from './base.entity';
import { ItemListEntity } from './item-list.entity';
import { RbacRoleEntity } from './rbac-role.entity';

/**
 * A role an item list is shared with (PD-15839); only meaningful while the
 * list's visibility is 'role'.
 */
@Index('idx_item_list_role_unique', ['itemListId', 'roleId'], {
	unique: true,
})
@Index('idx_item_list_role_list', ['itemListId'])
@Index('idx_item_list_role_role', ['roleId'])
@Entity('item_list_role')
export class ItemListRoleEntity extends BaseEntity {
	@Column('int', { name: 'fk_item_list__id', unsigned: true })
	public itemListId!: number;

	@Column('int', { name: 'fk_rbac_role__id', unsigned: true })
	public roleId!: number;

	@ManyToOne(() => ItemListEntity, (list) => list.sharedRoles, {
		onDelete: 'CASCADE',
		onUpdate: 'RESTRICT',
	})
	@JoinColumn([{ name: 'fk_item_list__id', referencedColumnName: 'id' }])
	public itemList!: ItemListEntity;

	@ManyToOne(() => RbacRoleEntity, {
		onDelete: 'CASCADE',
		onUpdate: 'RESTRICT',
	})
	@JoinColumn([{ name: 'fk_rbac_role__id', referencedColumnName: 'id' }])
	public role!: RbacRoleEntity;
}
